
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blur-background",
      function () {
        return require("private-next-pages/blur-background/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blur-background"])
      });
    }
  